// import external dependencies
import "jquery";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";
import taxVolume from "./routes/taxVolume";
import templateIssuesArchive from "./routes/templateIssuesArchive";

// https://discourse.roots.io/t/how-to-use-font-awesome-5-in-your-sage-theme/11737
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter, faInstagram, faVimeoV } from "@fortawesome/free-brands-svg-icons";
library.add(faFacebookF, faTwitter, faInstagram, faVimeoV);
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Taxonomy Volume
  taxVolume,
  // Template Issues Archive
  templateIssuesArchive,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(checkStyleIsLoaded);

// Check if style is loaded (for local development)
// see https://bit.ly/2SdRldr
function checkStyleIsLoaded() {
  // Get the current opacity of the body tag
  const opacity = window
    .getComputedStyle(document.body)
    .getPropertyValue("opacity");
  if (opacity === "1") {
    routes.loadEvents();
  } else {
    setTimeout(checkStyleIsLoaded, 100);
  }
}



// WEBPACK FOOTER //
// ./scripts/main.js